// extracted by mini-css-extract-plugin
export default {"showMobile":"CustomizeStep-module-showMobile-35QXW"};